import { HotTopicsPeriod } from '../platform-settings/platform-settings.enums';
import type { DashboardDTO } from './dashboard.dto';

export const HOT_TOPIC_COUNT = 5; // Number of MAIN hot topics to display in the dashboard (excluding the "Undefined" fallback topic)

export const DEFAULT_DASHBOARD_DATA: DashboardDTO = {
  botName: 'Unknown Bot',
  unFactCheckedItemsCount: 0,
  currentWeek: {
    startDate: '',
    endDate: '',
  },
  conversationsCount: {
    singleQuestionsCount: 0,
    groupConversationsCount: 0,
  },
  leadsGenAnalysis: {
    leadsGenerated: 0,
  },
  totalConversationCount: 0,
  conversationalAnalysis: {
    totalQuestions: 0,
    uniqueUsers: 0,
    percentageChange: 0,
    changeDirection: 'same',
    mostActiveDay: 'Unknown',
    mostActiveStartHour: 0,
    mostActiveEndHour: 0,
    maxActivity: 0,
    hotTopics: [],
    hotTopicsEnabled: false,
    hotTopicsPeriod: HotTopicsPeriod.DAILY,
    hotTopicsDisplayLimit: HOT_TOPIC_COUNT,
    timeSavedEnabled: false,
    mostFrequentQuestionInfo: {
      question: '',
      frequency: 0,
    },
  },
  didYouKnow: '',
  aiAccuracy: {
    accuracy: 0,
    date: new Date().toISOString(),
  },
  aiAccuracyBenchmark: {
    enabled: true,
    value: 75,
  },
  aiChartSettings: {
    showSubjective: false,
    showCombined: false,
    showObjective: true,
  },
  certified: false,
  accuracyTests: [],
  featureAccesses: {
    leadsInterestedCard: false,
    researchQuestionsCard: false,
    workflowAutomatedCard: false,
    handoverToHumanCard: false,
    csatCard: false,
    ticketDeflectionCard: false,
  },
  csat: {
    score: 0,
    configured: false,
  },
  ticketDeflection: {
    ratio: 0,
  },
};
